"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LowerNavBarContainer = exports.UpperNavBarContainer = exports.NavBarContainer = exports.TitleContainer = exports.ActionWrapper = exports.ActionsContainer = void 0;

var _designLanguage = require("@doordash/design-language");

var _constants = require("./constants");

var _types = require("./types");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _templateObject, _templateObject2;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ActionsContainer = (0, _styledComponents["default"])(_designLanguage.InlineChildren).attrs(function () {
  return {
    size: _designLanguage.InlineChildren.Sizes.XxSmall,
    alignItems: _designLanguage.InlineChildren.Alignment.Center
  };
}).withConfig({
  displayName: "styles__ActionsContainer",
  componentId: "sc-v9lptc-0"
})(["height:100%;flex-shrink:0;", ";&:first-child{margin-left:-", "px;}&:last-child{margin-right:-", "px;}"], function (props) {
  return (// This is to solve an issue with the white background color in the plain buttons rendered for actions
    props.noContentPadding && (0, _styledComponents.css)(["button{background:transparent;}"])
  );
}, _designLanguage.Inset.Sizes.XxSmall, _designLanguage.Inset.Sizes.XxSmall);
exports.ActionsContainer = ActionsContainer;

var ActionWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__ActionWrapper",
  componentId: "sc-v9lptc-1"
})(["flex-shrink:0;"]);

exports.ActionWrapper = ActionWrapper;

var TitleContainer = _styledComponents["default"].div.withConfig({
  displayName: "styles__TitleContainer",
  componentId: "sc-v9lptc-2"
})(["display:flex;align-items:center;flex-grow:1;min-width:0;", ";"], function (_ref) {
  var textAlign = _ref.textAlign;
  return textAlign === _constants.TextAlignments.Center ? 'justify-content: center' : undefined;
});

exports.TitleContainer = TitleContainer;
var NavBarContainer = (0, _designLanguage.withTheming)(_styledComponents["default"].nav.withConfig({
  displayName: "styles__NavBarContainer",
  componentId: "sc-v9lptc-3"
})(["", ";", ";padding:", ";", ""], function (props) {
  return props.isRaised && (0, _styledComponents.css)(["box-shadow:", ";"], _designLanguage.Shadows.Base);
}, function (props) {
  return props.isSeparatorVisible && (0, _styledComponents.css)(["border-bottom:1px solid ", ";"], props.theme.Colors.BorderPrimary);
}, function (props) {
  return props.noContentPadding ? "0px" : props.useDynamicPadding ? "".concat(props.theme.Spacing.NavBarPaddingVerticalLarge, "px ").concat(props.theme.Spacing.NavBarPaddingHorizontalLarge, "px") : "".concat(_designLanguage.Spacing.Small, "px");
}, function (props) {
  return props.useDynamicPadding && !props.noContentPadding && (0, _styledComponents.css)(["", " ", ""], _designLanguage.Media.Tablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding:\n      ", "px ", "px};\n  "])), props.theme.Spacing.NavBarPaddingVerticalMedium, props.theme.Spacing.NavBarPaddingHorizontalMedium), _designLanguage.Media.Mobile(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding:\n      ", "px ", "px};\n  "])), props.theme.Spacing.NavBarPaddingVerticalSmall, props.theme.Spacing.NavBarPaddingHorizontalSmall));
}));
exports.NavBarContainer = NavBarContainer;

var UpperNavBarContainer = _styledComponents["default"].div.withConfig({
  displayName: "styles__UpperNavBarContainer",
  componentId: "sc-v9lptc-4"
})(["display:flex;align-items:", ";> * + *{margin-left:", "px;}"], function (_ref2) {
  var titleSize = _ref2.titleSize;
  return titleSize === _types.TitleSizes.Small ? 'center' : 'flex-start';
}, _designLanguage.Inset.Sizes.Small);

exports.UpperNavBarContainer = UpperNavBarContainer;

var LowerNavBarContainer = _styledComponents["default"].div.withConfig({
  displayName: "styles__LowerNavBarContainer",
  componentId: "sc-v9lptc-5"
})(["display:flex;align-items:center;", ";"], function (_ref3) {
  var textAlign = _ref3.textAlign;
  return textAlign === _constants.TextAlignments.Center ? 'justify-content: center' : undefined;
});

exports.LowerNavBarContainer = LowerNavBarContainer;